import { render, staticRenderFns } from "./Presell.vue?vue&type=template&id=64c4847e&scoped=true"
import script from "./Presell.vue?vue&type=script&lang=js"
export * from "./Presell.vue?vue&type=script&lang=js"
import style0 from "./Presell.vue?vue&type=style&index=0&id=64c4847e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c4847e",
  null
  
)

export default component.exports